module.exports = __webpack_public_path__ + "static/media/picto-circles-white.f61a2b7b.svg";